import { CHAT_USER_TAG } from '@/utils/constants';

import type { TFilterTab } from '../conversations-filter.types';

export const FILTER_TABS: TFilterTab[] = Object.entries(CHAT_USER_TAG).map(
	([tag, text]) => ({ tag, text }),
);

export const CONVERSATIONS_FILTER_STRINGS = {
	SPAM_MESSAGE: 'As mensagens nesta aba estão marcadas como indesejadas e não são indicadas para negociação na Webmotors.',
} as const;

export const FILTER_EVENT_NAMES: Record<string, string> = {
	NaturalPerson: 'clickGaragemPessoasfisicas',
	LegalPerson: 'clickGaragemLojistas',
	Spam: 'clickGaragemSpam',
	Blocked: 'clickGaragemBloqueados',
} as const;
